require('./bootstrap');

livalo =  {
    init: function() {
        this.pathname = window.location.pathname;
        this.hash = window.location.hash;
        this.supportsPlaceholder();
        gliv.init(); // <== global JS for all pages of site
        video.init(); // <== global video JS for all videos on this SPECIFIC page (NON-MODAL VIDEOS)
        accordions.init();
        overlays.init();
        nav.init();
        isi.init();

        if (document.body.classList.contains('home')){
            home.init();
        }
        if (document.body.classList.contains('goal-getter-form')){
            goalGetter.init();
        }
        if (document.body.classList.contains('coupon-page')){
            copay.init();
        }
        if( document.body.classList.contains("cholesterol") ){
            cholesterol.init();
        }
        if( document.body.classList.contains("diet") ){
            diet.init();
        }
        if( document.body.classList.contains("exercise") ){
            exercise.init();
        }
        if( document.body.classList.contains("reminders") ){
            reminders.init();
        }
        if( document.body.classList.contains("optin") ){
            optin.init();
        }
        if( document.body.classList.contains("assessment") ){
            ddg.init();
        }
        if( document.body.classList.contains("results") ){
            results.init();
        }
        if( document.body.classList.contains("specific-patients") ){
            specificPatients.init();
        }

        if( document.body.classList.contains("lander-page") ){
            landerPage.init();
        }
        

        if( document.body.classList.contains("mmit-data") ){
            $('script[src="/js/jquery-3.1.1.min.js"]').after('<script type="text\/javascript" src="\/js\/datatables.min.js"></script>');
            mmit.init();
        }

        if ( this.pathname === '/' && (this.hash === "#safety" || this.hash === '#isi')){
            $html.classList.add('show-isi');
            document.querySelector('footer').classList.add('is--open');
        }

        if ( this.pathname === '/' && (this.hash === "#privacy" || this.hash === '#terms' || this.hash === '#copyright')){
            $html.classList.add('overlay-showing');
            document.querySelector(this.hash).classList.add('show-overlay');
        }

        if ( (this.pathname === '/savings/challenge-card' || this.pathname === '/savings/challenge-card/') && (this.hash === "#OfferDetails")){
            var currentURL = window.location.href.replace(window.location.origin, '').replace(/\/$/, "");

            if (currentURL === '/savings/challenge-card/#OfferDetails') {
                window.location = window.location.origin + '/supporting-you-on-livalo/coupon/';
            }
        }

        if ( (this.pathname === '/supporting-you-on-livalo/coupon' || this.pathname === '/supporting-you-on-livalo/coupon/') && (this.hash === "#OfferDetails")){
            $html.classList.add('overlay-showing');
            document.querySelector("#savings-terms-overlay").classList.add('show-overlay');
        }
    },
    supportsPlaceholder: function() {
        if ( !Modernizr.placeholder ) {
            var $placeholder = $( "input[type=email]" );
            $placeholder.each( function () {
                var $this = $( this );
                $this.attr( "value" ,$this.attr( "data-value" ) );
            } );
        }
    }
};
livalo.init();
